

















import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../main/components/main-header/main-header.vue";
import NavLeft from "../components/nav-left.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
  },
})
export default class Sjcj extends Vue {
  private window: any = window;
}
